import React, { useState } from "react";
import NavBar from "components/tabs/TabsHolder";
import ProfitSettings from "../../../../settings/subFeatures/settingsTabs/dealDefault/ProfitSettings";
import CommissionSettings from "../../../../settings/subFeatures/settingsTabs/dealDefault/CommissionSetting";
import TaxDefaults from "../../../../settings/subFeatures/settingsTabs/dealDefault/TaxDefaults";
import shallow from "zustand/shallow";
import useCurrentSettingStore from "../../../../../stores/SettingStore";
import { saveSettings } from "../../../../../api/SettingsAPI";
import {
	saveFailAlert,
	saveSuccessAlert,
} from "../../../../../utils/alertUtils";
import { showApiError } from "../../../../../utils/errorRoutingUtils";
import LeaseSettings from "./LeaseSetting";
import { useFromLocations } from "../../../../../stores/LocalStorageHelper";

/**
 * Tax, profit, and commission settings for the settings page.
 * This tab modifies the settings for all deals created after modifying
 */
const DealDefaultSettings = () => {
	const hasLease = useFromLocations("ls");
	const [activeTabName, setActiveTabName] = useState("Tax Settings");

	const tabs = ["Tax Settings", "Profit Settings", "Commission Settings"];
	if (hasLease) tabs.push("Lease/RTO Settings");

	const {
		profitSettings,
		taxDefaults,
		commissionSettings,
		editProfitSettings,
		editProfitSettingsValue,
		editCommissionSettings,
		editCommissionSettingsValue,
		editTaxDefaults,
		editTaxDefaultsValue,
	} = useCurrentSettingStore((state) => state, shallow);

	const save = () => {
		const settings = {
			taxDefaults,
			profitSettings,
			commissionSettings,
		};

		saveSettings(settings).then(
			(res) => {
				console.log(res);
				saveSuccessAlert();
			},
			(err) => {
				if (!err.isGeneralError) {
					showApiError(err, saveFailAlert);
				}
			}
		);
	};

	const tabComponents = [
		<TaxDefaults
			isDeal={false}
			taxDefaults={taxDefaults}
			editTaxDefaults={editTaxDefaults}
			editTaxDefaultsValue={editTaxDefaultsValue}
		/>,
		<ProfitSettings
			isDeal={false}
			profitSettings={profitSettings}
			editProfitSettings={editProfitSettings}
			editProfitSettingsValue={editProfitSettingsValue}
		/>,
		<CommissionSettings
			isDeal={false}
			commissionSettings={commissionSettings}
			editCommissionSettings={editCommissionSettings}
			editCommissionSettingsValue={editCommissionSettingsValue}
		/>,
		<div className="pt-8 col-md-12 d-flex justify-content-center">
			<LeaseSettings isDeal={false} />,
		</div>,
	];

	return (
		<div className="col">
			<NavBar
				navClass="nav-pills-secondary justify-content-center nav nav-pills"
				tabs={tabs}
				tabComponents={tabComponents}
				getTabName={setActiveTabName}
			/>

			{activeTabName !== "Lease/RTO Settings" && (
				<div className="btn btn-success float-button" onClick={save}>
					<i className="nc-icon nc-check-2" /> Save
				</div>
			)}
		</div>
	);
};

export default DealDefaultSettings;
